<template>
  <v-app
    :class="
      $router.currentRoute.path.includes('/reports/') ? 'reportPage' : 'project'
    "
  >
    <div
      class="text-light not-origin"
      v-if="!allowedOrigins.includes(origin) && showAlert"
    >
      شما در حال استفاده از
      <a :href="origin" target="_blank"> نسخه آزمایشی سامانه تقسیم کار ملی </a>
      هستید. لطفا جهت استفاده از سامانه اصلی از
      <a
        href="https://biodcportal.com"
        target="_blank"
        rel="noopener noreferrer"
        >این آدرس</a
      >
      استفاده بفرمایید.
    </div>
    <router-view
      :key="$route.fullPath"
      :class="
        origin != 'https://biodcportal.com' && showAlert
          ? 'not-origin-content'
          : ''
      "
    ></router-view>
  </v-app>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      origin: "",
      allowedOrigins: [
        "https://biodcportal.com",
        "https://www.biodcportal.com",
      ],
    };
  },
  computed: {
    showAlert() {
      let route = this.$route.fullPath.split("/")[1];
      if (route) {
        if (
          route == "admin" ||
          route == "head" ||
          route == "referee" ||
          route == "university" ||
          route == "company" ||
          route == "researcher"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.origin = window.location.origin;
  },
};
</script>

<style lang="scss">
.not-origin {
  width: 100%;
  text-align: center;
  background-color: red;
  position: fixed;
  top: 0;
  left: 0;
  line-height: 35px;
  z-index: 1000;
}
.not-origin-content {
  margin-top: 35px;
}
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";

@font-face {
  font-family: iransans;
  src: url("assets/fonts/IRANSans(FaNum).ttf");
}
body {
  font-family: iransans !important;
}
.project {
  font-family: iransans !important;
  background-color: #e5e5e5 !important;
}
.reportPage {
  font-family: iransans !important;
  background-color: #fff !important;
}
</style>
